import styled from "styled-components";

const Span = styled.span`
  cursor: pointer;
  padding: 6px 0 6px 10px;
`;
export default Span;
